export enum FILE_TYPE {
  RECOMMENDATION = 'RECOMMENDATION',
  REGULAR = 'REGULAR',
}

export enum CALENDAR_FIRST_DIRECTION {
  PATRIOTISM_AND_HISTORICAL_MEMORY = 'PATRIOTISM_AND_HISTORICAL_MEMORY',
  EDUCATION_AND_KNOWLEDGE = 'EDUCATION_AND_KNOWLEDGE',
  VOLUNTEERING = 'VOLUNTEERING',
  CULTURE_AND_ART = 'CULTURE_AND_ART',
  DIPLOMACY_AND_INTERNATIONAL_RELATIONS = 'DIPLOMACY_AND_INTERNATIONAL_RELATIONS',
  MEDIA_AND_COMMUNICATIONS = 'MEDIA_AND_COMMUNICATIONS',
  COMMUNITY_NATIVE_FAVORITE = 'COMMUNITY_NATIVE_FAVORITE',
  SPORT = 'SPORT',
  WORK_PROFESSION_AND_OWN_BUSINESS = 'WORK_PROFESSION_AND_OWN_BUSINESS',
  SCIENCE_AND_TECHNOLOGY = 'SCIENCE_AND_TECHNOLOGY',
  TOURISM_AND_TRAVEL = 'TOURISM_AND_TRAVEL',
  ECOLOGY_AND_NATURE_PROTECTION = 'ECOLOGY_AND_NATURE_PROTECTION',
  HEALTHY_LIFESTYLE = 'HEALTHY_LIFESTYLE',
}

export interface PreparedFormFileValue {
  id: string;
  name: string;
  fileType: FILE_TYPE;
  direction?: CALENDAR_FIRST_DIRECTION | null;
  path?: string | null;
  order?: number | null;
  folderId?: string;
  file: {
    title: string;
    src: string | { name: string };
  };
}

export interface FileFormValue {
  id?: string;
  name: string;
  fileType: FILE_TYPE;
  direction?: CALENDAR_FIRST_DIRECTION | null;
  path?: string | null;
  order?: number | null;
  folderId?: string;
  file: {
    rawFile?: File;
    title: string;
    src: string | { name: string };
  }
}

export interface FolderFormValue {
  id: string;
  name: string;
  parentId?: string;
}

export interface MaterialFile {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  key: string;
  name: string;
  url: string;
}

export interface MaterialFileResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  name: string;
  fileType?: FILE_TYPE | null;
  direction?: CALENDAR_FIRST_DIRECTION | null;
  materialId: string;
  fileId: string;
  path?: string | null;
  order?: number | null;
  file: MaterialFile;
}
